import React from "react"
import * as S from "./background-pattern.styles"

const BackgroundPattern = ({ children, img, as, ...props }) => {
  if (!img) return

  let image = img.sourceUrl ?? img.publicURL ?? img

  return (
    <S.Wrapper bgimage={image} as={as} {...props}>
      {children}
    </S.Wrapper>
  )
}

export default BackgroundPattern
